import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'dashboard-loader',
  templateUrl: './dashboard-loader.component.html',
  styleUrls: ['./dashboard-loader.component.scss']
})

export class DashboardLoaderComponent implements OnInit {

  @Input() loading: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
